/**
 * Default: Components / Custom > Horizontal rule
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {observeInView} from "@ifabnpm/bootstrap/utils/observer.js";

import {
	SelectorEngine,
	Manipulator
} from '@ifabnpm/bootstrap/dom.js';

// -------
// Private
// -------


// ------
// Public
// ------

/**
 * Listen initialisieren und anpassen.
 *
 * @returns {Promise<void>}
 */
const init = async (o = {}) => {
	//
	// Replace native `<hr/>`
	//

	const collectionHrNative = SelectorEngine.find('hr');

	if (collectionHrNative.length > 0) {
		const hrNativeReplacement = `<div class="horizontal-rule" data-c="horizontal-rule" role="separator">
			<svg class="svg-line -h " aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 1240 12" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="#svg-line-h"/>
			</svg>
		</div>`;

		for (const element of collectionHrNative) {
			Manipulator.elementAfter(hrNativeReplacement, element);

			element.remove();
		}
	}

	//
	// Check ´in view´ and animate `.horizontal-rule`
	//

	const collectionHorizontalRule = SelectorEngine.find('.horizontal-rule');

	for (const element of collectionHorizontalRule) {
		observeInView(element, {
			onEnterViewport: (target) => {
				if (target) {
					Manipulator.addClass(target, '-animate');
				}
			},
			// onLeaveViewport: (event) => {},
			observer       : {
				threshold: 0
			}
		});
	}
};

// Export
export default {
	init: init
};
